import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import BaseComponent from 'utils/BaseComponent'
import request from 'utils/request'

import Button from 'components/Button'

import { CLAIM_UPDATES } from 'constants'

import { statusChanged } from 'components/RequestStatus/actions'
import { notificationFetched } from '../actions'

import './styles.scss'

export class DeleteNotification extends BaseComponent {

  constructor() {
    super()

    this._bind('_confirmDelete')
  }


  _confirmDelete() {
    const url =  `${CLAIM_UPDATES(this.props.claimId)}${this.props.notificationId}/`


    this.props.updateRequestStatus('progress', 'Eliminando notificación...')

    request(url, {
      method: 'DELETE'
    })
      .then((res) => {
        let newNotifications = this.props.notification_list.slice()
        newNotifications.splice(this.props.notification_list.indexOf(this.props.notification), 1)
        this.props.updateRequestStatus('ok', 'Notificación Eliminada')
        this.props.notificationFetched(newNotifications)
      })
      .catch((err) => {this.props.updateRequestStatus('error', 'No pudimos eliminar la notificación')})

    this.context.toggleModal(false)
  }

  render() {
    return (
      <div id="DeleteNotification" className="DeleteNotification Modal__content">
        <div className="SinisterModal__header d-flex justify-content-between align-items-center">
          <h1>Eliminar notificación</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <p className="message">Seguro que quieres eliminar esta notificación</p>
        <div className="f-flex SinisterModal__form">
          <div className="controls">
            <div className="controls d-flex justify-content-center">
              <Button className="button"
                      onClick={this._confirmDelete}
                      size="big"
                      buttonType="primary">Confirmar</Button>
              <Button className="button"
                      onClick={() => this.context.toggleModal(false)}
                      size="big"
                      buttonType="danger">Cancelar</Button>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

DeleteNotification.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}



const mapStateToProps = (state) => {
  return {
    notification_list: state.claimNotification.get('notification_list')
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    notificationFetched: (notification_list) => dispatch(notificationFetched(notification_list)),
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}


export default connect(mapStateToProps, mapDispatchToProps)(DeleteNotification)



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Claim/Notifications/NotificationList/DeleteNotification.js